<template>
  <b-card no-body>
    <b-overlay
      :show="loading"
      variant="white"
      spinner-variant="primary"
      rounded="sm"
    >
      <b-card-title class="m-0 py-1 px-2">
        <b-row align-h="end" align-v="center">
          <b-col cols="auto">
            <b-link
              v-access="{
                resource: $data.$constants.RESOURCES.RESOURCE_PURCHASE_INVOICES,
                resourceAction:
                  $data.$constants.RESOURCE_ACTIONS.RESOURCE_ACTION_ALL,
              }"
              :to="{
                name: 'editPurchaseInvoice',
                params: { id: $route.params.id },
              }"
              class="d-inline-block px-50 text-indigo"
            >
              <feather-icon
                v-b-tooltip.hover
                title="Editar"
                icon="Edit2Icon"
                size="18"
              />
            </b-link>
            <b-link
              v-access="{
                resource: $data.$constants.RESOURCES.RESOURCE_PURCHASE_INVOICES,
                resourceAction:
                  $data.$constants.RESOURCE_ACTIONS.RESOURCE_ACTION_ALL,
              }"
            >
              <span
                class="d-inline-block px-50 text-danger"
                @click="handleDeleteSaleInvoiceButtonClick()"
              >
                <feather-icon
                  v-b-tooltip.hover
                  title="Eliminar"
                  icon="TrashIcon"
                  size="18"
                />
              </span>
            </b-link>
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col cols="auto">
            <small class="text-dark font-weight-bold">
              Nº Factura proveedor
              {{ purchaseInvoice ? purchaseInvoice.provider_code : "" }}
            </small>
            <div class="font-weight-bold text-capitalize text-dark mb-0">
              {{
                purchaseInvoice && purchaseInvoice.provider
                  ? purchaseInvoice.provider.name
                  : ""
              }}
              <StatusSelect
                v-model="status"
                class="font-small-3 d-inline-block"
                :type="statusType"
                :clearable="false"
                @selection-change="handleStatusSelectionChange"
              />
              <!-- <StatusBadge
                class="font-small-3 ml-2"
                :status="purchaseInvoice ? purchaseInvoice.status.name : ''"
              />
              <StatusBadge
                v-if="purchaseInvoice && 
                  purchaseInvoice.send_payment_document && 
                  purchaseInvoice.send_payment_document === 1
                "
                class="font-small-3 ml-1" 
                :status="'Envio doc. pago'" 
                :text="'Envio doc. pago'"
                :variant="'light-success'"
              /> -->
            </div>
            <div>
              <small class="font-weight-bold">
                {{ purchaseInvoice ? purchaseInvoice.provider.cif : "" }}
              </small>
            </div>
            <div v-if="!editDueDate">
              <small>
                <span class="font-weight-bold">
                  {{ purchaseInvoiceDate }}
                </span>
                vence
                <span>
                  {{ purchaseInvoiceDueDate }}
                </span>
                computo
                <span>{{  purchaseComputationDate }}</span>  
              </small>
              <b-link
                class="d-inline-block text-indigo pr-1"
                @click="handleSaveEditDueDate(true)"
              >
                <feather-icon
                  v-b-tooltip.hover
                  title="Editar"
                  icon="Edit2Icon"
                  size="18"
                />
              </b-link>
            </div>
            <div v-if="editDueDate" class="d-flex py-1">
              <b-form-datepicker
                :value="dueDate"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                size="sm"
                :hide-header="true"
                placeholder="Fecha"
                :label-help="null"
                start-weekday="1"
                @input="saveDueDate($event)"
              />
              <b-button
                size="sm"
                variant="danger"
                @click="handleSaveEditDueDate(false)"
                >Cancelar
              </b-button>
            </div>
            <div>
               <small class="font-weight-bold text-capitalize text-dark mt-3">{{ purchaseInvoice ? purchaseInvoice.bc_id : "" }}</small>
            </div> 
          </b-col>
        </b-row>
      </b-card-title>
      <hr class="m-0" />
      <ProfilePanel :profile="purchaseInvoiceProfile" />
      <ContactsPanel
        v-if="purchaseInvoice && purchaseInvoice.contact"
        :title="'Contacto facturación'"
        :contacts="[purchaseInvoice.contact]"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PurchaseInvoicesApi from "@/api/purchase-invoices-api";
import ProfilePanel from "@/components/ui/panel/ProfilePanel.vue";
import ContactsPanel from "@/components/ui/panel/ContactsPanel.vue";
// import StatusBadge from "@/components/status/badge/StatusBadge.vue";
import StatusSelect from "@/components/status/select/StatusSelect.vue";
import { PURCHASE_INVOICES_STATUS_TYPE } from "@/api/status-api";

export default {
  name: "PurchaseInvoicesProfileCard",
  components: {
    // StatusBadge,
    ProfilePanel,
    ContactsPanel,
    StatusSelect,
  },
  data() {
    return {
      editDueDate: false,
      dueDate: "",
      loading: false,
      status: "",
      statusType: PURCHASE_INVOICES_STATUS_TYPE,
    };
  },
  computed: {
    ...mapGetters("purchaseInvoice", {
      purchaseInvoice: "getPurchaseInvoice",
      tab: "getTabSelected",
    }),
    origin() {
      return this.tab === 0 ? "invoice" : "fra";
    },
    purchaseInvoiceDate() {
      return this.purchaseInvoice?.invoice_date
        ? new Date(this.purchaseInvoice.invoice_date).toLocaleDateString()
        : "";
    },
    purchaseInvoiceDueDate() {
      return this.purchaseInvoice?.expiration_date
        ? new Date(this.purchaseInvoice.expiration_date).toLocaleDateString()
        : "";
    },
    purchaseComputationDate() {
      return this.purchaseInvoice?.computation_date
        ? new Date(this.purchaseInvoice.computation_date).toLocaleDateString()
        : "";
    },
    purchaseInvoiceRetentionExpiration() {
      return this.purchaseInvoice?.retention_expiration
        ? new Date(
            this.purchaseInvoice.retention_expiration
          ).toLocaleDateString()
        : "";
    },
    purchaseInvoiceProfile() {
      let info = [
        {
          label: "Número de factura de provedor",
          value: this.purchaseInvoice?.provider_code || "Sin Numero",
        },
        {
          label: "Obra",
          value: this.purchaseInvoice?.job?.project?.name || "Sin obra",
        },
        { label: "Retención", value: this.retentionText },
      ];
      if (this.origin === "fra") {
        info.push({
          label: "Partida",
          value: this.purchaseInvoice?.accounting_item?.name || "Sin partida",
        });
      } else {
        info.push(
          {
            label: "Pedido",
            value: this.purchaseInvoice?.order?.number || "Sin pedido",
          },
          {
            label: "División",
            value: this.purchaseInvoice?.division?.name || "Sin división",
          },
          {
            label: "Job",
            value: this.purchaseInvoice?.job?.name || "Sin Job",
            link: !!this.purchaseInvoice?.job,
            id: this.purchaseInvoice?.job?.id,
            aditionalInfo: this.purchaseInvoice?.job_contract?.name,
            routeName: "viewJob",
          },
          {
            label: "Categoría",
            value:
              this.purchaseInvoice?.category_group?.name || "Sin categoría",
          },
          {
            label: "Numero",
            value: this.purchaseInvoice?.number || "Sin numero",
          }
        );
      }
      return info;
    },
    retentionText() {
      if (!this.purchaseInvoice || !this.purchaseInvoice.retention_percent) {
        return "Sin retención";
      }

      if (this.purchaseInvoiceRetentionExpiration) {
        return `${this.purchaseInvoice.retention_percent} % vence ${this.purchaseInvoiceRetentionExpiration}`;
      }

      return `${this.purchaseInvoice.retention_percent} %`;
    },
  },
  watch: {
    purchaseInvoice: {
      handler() {
        this.status = this.purchaseInvoice.status;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("app", ["setLoading"]),
     ...mapActions("purchaseInvoice", ["loadPurchaseInvoice"]),
    async handleStatusSelectionChange(status) {
      this.loading = true;

      const item = { ...this.purchaseInvoice, status };

      delete item.documentation;

      try {
        await PurchaseInvoicesApi.edit(this.purchaseInvoice.id, item);
        this.$router.push({ name: "purchaseInvoices" });
      } catch (_) {
        this.status = this.purchaseInvoice.status;
      }
      this.loading = false;
    },
    async handleDeleteSaleInvoiceButtonClick() {
      const response = await this.$modal.show({
        title: "¿Está seguro?",
        text: `Se borrará el registro Nº${this.purchaseInvoice.code}.`,
      });

      if (!response.isConfirmed) {
        return;
      }

      this.setLoading(true);
      try {
        await PurchaseInvoicesApi.delete(this.purchaseInvoice?.id);
        await this.$router.push({ name: "purchaseInvoices" });
      } finally {
        this.setLoading(false);
      }
    },
    handleSaveEditDueDate(value) {
      this.dueDate = this.purchaseInvoice.expiration_date;
      this.editDueDate = value;
    },
    async saveDueDate(expiration_date) {
      this.loading = true;
      try {
        await PurchaseInvoicesApi.edit(
          this.$route.params.id,
          { expiration_date },
          false
        );
        await this.loadPurchaseInvoice(this.purchaseInvoice.id);
        this.$toast("Factura actualizada con éxito.");
        this.editDueDate = false;
      } catch (error) {
         this.$toast.error(
          "Ocurrio un error. Por favor inténtelo de nuevo mas tarde."
        );
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
